import { SvgIcon, SxProps } from "@mui/material";
import ChevronLeftSvg from "jsx:../../../Images/Icons/FontAwesome/light/chevron-left.svg";

export function ChevronLeftIcon(props: SxProps) {
    return <SvgIcon component={ChevronLeftSvg} inheritViewBox sx={props} />;
}
